var exports = {
  "i": "xaee3c4fa--dd1600--wrapper",
  "w": "xaee3c4fa--dd1600--skeleton-wrapper",
};

module.exports = exports;
